import React from "react";
import { connect } from "react-redux";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";

/// Css
import "./index.css";


/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";


/// Dashboard
import Home from "./components/Dashboard/Home";
/// Pages
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Login from "./pages/Login"
import ForgotPassword from "./pages/ForgotPassword"

import logo from '../images/logo/logo.png';
import logoText from '../images/logo/logo_text.png';
import Profile from "./components/Profile/Profile";
import ResetPassword from "./pages/ResetPassword";
import {
  ALL_USER_PERM,
} from "./permission";
import Document from "./components/Document";
import DocumentAddModal from "./components/Document/AddDocumentModal";
import AddUser from "./components/User/AddUser";
import UserPage from "./components/User/index" 

import UserDetails from "./components/User/UserDetails";

import DocumentDetails from "./components/Document/DocumentTab";
import EditDocument from "./components/Document/DocumentTab/DocumentDetail/EditDocument";
import EditDocumentVersion from "./components/Document/DocumentTab/DocumentVerison/EditDocumentVersion";
import EditUser from "./components/User/EditUser";

import AuditPage from "./components/Audit"
import AddDocumentVersion from "./components/Document/DocumentTab/DocumentVerison/AddVersion";
import AddMeasurementSheet from "./components/Document/DocumentTab/MeasurmentSheet/AddMeasurmentSheet";
import EditMeasurementSheet from "./components/Document/DocumentTab/MeasurmentSheet/EditMeasurmentSheet";
import TESheet from "./components/TE-Sheet";
import MeasurementSheetDetails from "./components/TE-Sheet/MeasurementSheetDetails";
import AddCircularSheet from "./components/TE-Sheet/Circular/AddCircular";
import CircularDetails from "./components/TE-Sheet/Circular/CircularDetails";
import Quiz from "./components/Quiz";
import AddQuiz from "./components/Quiz/AddQuiz";
import QuizDetails from "./components/Quiz/QuizDetails";
import EditQuiz from "./components/Quiz/EditQuiz";
import Division from "./components/Division/index";
import AddChecklist from "./components/Audit/AddChecklist";
import AuditDetails from "./components/Audit/AuditDetails";
import EditChecklist from "./components/Audit/EditChecklist";
import GenerateAuditReportModal from "./components/Audit/GenerateReport";
import GenerateReportModal from "./components/TE-Sheet/Circular/GenerateReport";
import Calibration from "./components/Calibration";
import CalibrationDetails from "./components/Calibration/CalibrationDetails";

const allroutes = [
  // Dashboard
  { url: "dashboard", element: <Home />, accessRole: ALL_USER_PERM },
  { url: "profile", element: <Profile />, accessRole: ALL_USER_PERM },
  { url: "document", element: <Document />, accessRole: ALL_USER_PERM },
  { url: "audit", element: <AuditPage />, accessRole: ALL_USER_PERM },
  { url: "add-document", element: <DocumentAddModal />, accessRole: ALL_USER_PERM },
  { url: "document/:id", element: <DocumentDetails />, accessRole: ALL_USER_PERM },
  { url: "edit-document/:id", element: <EditDocument />, accessRole: ALL_USER_PERM },
  { url: "edit-document-version/:id", element: <EditDocumentVersion />, accessRole: ALL_USER_PERM },
  { url: "user", element: <UserPage />, accessRole: ALL_USER_PERM },
  { url: "user/:id", element: <UserDetails />, accessRole: ALL_USER_PERM },
  { url: "edit-user/:id", element: <EditUser />, accessRole: ["SuperAdmin", "Admin"] },
  { url: "add-user", element: <AddUser />, accessRole: ["SuperAdmin", "Admin"] },
  { url: "add-version/:id", element: <AddDocumentVersion />, accessRole: ALL_USER_PERM },
  { url: "add-sheet", element: <AddMeasurementSheet />, accessRole: ALL_USER_PERM },
  { url: "edit-sheet", element: <EditMeasurementSheet />, accessRole: ALL_USER_PERM },
  { url: "te-sheet", element: <TESheet />, accessRole: ALL_USER_PERM },
  { url: "te-sheet/:id", element: <MeasurementSheetDetails />, accessRole: ALL_USER_PERM },
  { url: "add-circular", element: <AddCircularSheet />, accessRole: ALL_USER_PERM },
  { url: "circular/:id", element: <CircularDetails />, accessRole: ALL_USER_PERM },
  { url: "quiz", element: <Quiz />, accessRole: ALL_USER_PERM },
  { url: "add-quiz", element: <AddQuiz />, accessRole: ["SuperAdmin"] },
  { url: "quiz/:id", element: <QuizDetails />, accessRole: ALL_USER_PERM },
  { url: "edit-quiz/:id", element: <EditQuiz />, accessRole: ["SuperAdmin"] },
  { url: "division", element: <Division/>, accessRole: ["SuperAdmin"] },
  { url: "audit", element: <AuditPage/>, accessRole: ALL_USER_PERM },
  { url: "add-checklist", element: <AddChecklist/>, accessRole: ALL_USER_PERM },
  { url: "audit/:id", element: <AuditDetails/>, accessRole: ALL_USER_PERM },
  { url: "edit-audit", element: <EditChecklist/>, accessRole: ALL_USER_PERM },
  { url: "audit-report", element: <GenerateAuditReportModal/>, accessRole: ALL_USER_PERM },
  { url: "circular-report", element: <GenerateReportModal/>, accessRole: ALL_USER_PERM },
  { url: "calibration", element: <Calibration/>, accessRole: ALL_USER_PERM },
  { url: "calibration/:id", element: <CalibrationDetails/>, accessRole: ALL_USER_PERM },
];

const FlashScreen = () => {
  return (
    <div className="flash-screen">
      <div className="flash-body">
        <img src={logo} alt="" width={'50px'} style={{ marginRight: '0.6rem' }} />
        <img src={logoText} alt="" width={'150px'} />
      </div>
    </div>
  )
}

const Markup = ({ isAuthenticated, isCheckingAuth, role, sideMenu }) => {
  const NotFound = () => <Error404 />

  function MainLayout() {
    return (
      <div id="main-wrapper" className={`show ${sideMenu ? "menu-toggle" : ""}`}>
        <Nav />
        <div className="content-body" style={{ minHeight: "calc(100vh - 45px)" }}>
          <Outlet />
        </div>
        <Footer />
      </div>
    )
  }

  const HandleUserAuthentication = ({ data }) => {
    if (!isAuthenticated) {
      return <Navigate to='/' />
    } else if (data.accessRole.includes(role)) {
      return data.element
    } return <Error403 />
  };

  return (isCheckingAuth ? <FlashScreen /> :
    <>
      <Routes>
        <Route path='/' exact element={isAuthenticated ? <Navigate to='/dashboard' /> : <Login />} />
        <Route path='/forgot-password' exact element={isAuthenticated ? <Navigate to='/dashboard' /> : <ForgotPassword />} />
        <Route path='/reset-password' exact element={isAuthenticated ? <Navigate to='/dashboard' /> : <ResetPassword />} />
        <Route element={<MainLayout />} >
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={<HandleUserAuthentication data={data} />}
            />
          ))}
        </Route>
        <Route path='*' element={<NotFound />} />
      </Routes>
      <ScrollToTop />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    role: state.auth.user?.role || "User",
    sideMenu: state.sideMenu,
    isAuthenticated: state.auth.user,
    isCheckingAuth: state.auth.isCheckingAuth
  };
};

export default connect(mapStateToProps)(Markup);
